import { UserService } from 'app/core/services/user.service';
import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TimeoutEnum } from 'app/core/enum/timeout.enum';
import { AuthStateService } from 'app/core/services/auth-state.service';
import { LoginService } from 'app/core/services/login.service';
import { User } from 'app/shared/models/user';
import { AgresSpinnerService } from 'app/shared/components/agres-spinner/agres-spinner.service';
import { FullDataExportService } from 'app/core/services/full-data-export.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  standalone: false,
  selector: 'app-delete-account',
  templateUrl: './delete-account.component.html',
  styleUrls: ['./delete-account.component.scss'],
})
export class DeleteAccountComponent implements OnInit {
  public usuario: User = new User();
  public isConfirmPasswordVisible = false;

  public myDeleteForm: FormGroup;
  public deleteData: { email: string; password: string } = {
    email: '',
    password: '',
  };
  public loginExecuting = false;
  public downloadingAllData = false;

  private readonly formBuilder = inject(FormBuilder);
  private readonly translate = inject(TranslateService);
  private readonly loginService = inject(LoginService);
  private readonly authState = inject(AuthStateService);
  private readonly deleteUserService = inject(UserService);
  private readonly router = inject(Router);
  private readonly toastr = inject(ToastrService);
  private readonly fullDataExportService = inject(FullDataExportService);

  ngOnInit() {
    this.myDeleteForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
    });
  }

  onSubmit() {}

  downloadAllMyData() {
    this.downloadingAllData = true;
    this.fullDataExportService.download().subscribe({
      next: () => {
        this.downloadingAllData = false;
      },
      error: () => {
        this.translate
          .get('global.validate.error-generic')
          .subscribe((msg: string) => {
            this.toastr.error(msg, '', {
              positionClass: 'toast-top-full-width',
              disableTimeOut: false,
            });
          });
        this.downloadingAllData = false;
      },
    });
  }

  backToProfile() {
    history.back();
  }

  confirmTogglePassword() {
    this.isConfirmPasswordVisible = !this.isConfirmPasswordVisible;
  }

  onDeleteUser() {
    this.loginExecuting = true;
    const email = this.myDeleteForm.value.email;
    const password = this.myDeleteForm.value.password;

    if (this.myDeleteForm.valid) {
      this.loginService.login(email, password).subscribe(
        (data: any) => {
          const lang = this.translate.currentLang || 'ptBR';
          this.deleteUserService.fakeDeleteUser(lang).subscribe(
            (res) => {
              this.authState.clearUserScopedData();
              this.translate
                .get('global.validate.deleted-account')
                .subscribe((result: string) => {
                  this.toastr.success(result, '', {
                    positionClass: 'toast-top-full-width',
                    disableTimeOut: false,
                  });
                  this.loginExecuting = false;
                });

              setTimeout(() => {
                this.router.navigate(['/login']);
              }, TimeoutEnum.MediumShort);
            },
            (error) => {
              console.error(error);
            },
          );
        },
        (error) => {
          if (error.status === 400) {
            this.translate
              .get('global.validate.user-login')
              .subscribe((res: string) => {
                this.toastr.error(res, '', {
                  positionClass: 'toast-top-full-width',
                  disableTimeOut: false,
                });
                this.loginExecuting = false;
              });
          }
        },
      );
    } else {
      this.translate
        .get('global.validate.fields')
        .subscribe((result: string) => {
          this.toastr.warning(result, '', {
            positionClass: 'toast-top-full-width',
            disableTimeOut: false,
          });
          this.loginExecuting = false;
        });
    }
  }
}
